import axios from 'axios';
import API_ROUTES from '../../routes/ApiRoutes.js';

// Extraer la llamada al backend (service)
export const forgotPasswordRequest = async (email) => {
    const response = await axios.post(
        API_ROUTES.FORGOT_PASSWORD,
        { email }
    );

    return response.data;
};

export const resetPasswordRequest = async (token, password) => {
    const response = await axios.post(
        `${API_ROUTES.RESET_PASSWORD}?token=${token}`,
        { password }
    );

    return response.data;
};